import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import businessModelActions from '../actions/businessModel';
import {DEEP_LINK_PARAM_TYPE, removeDeepLinkParams} from '../utils/localStorageDataHandler';
import {isPPM} from '../utils/validate';

const dispatchServiceError = (store, errorKey) => {
    store.dispatch(softwareDetailsActions.alertError(errorKey));
    store.dispatch(actions.enableLoadOverLay(false));
};

function validateSoftwareDetails(store, action) {
    const softwareDetails = action.payload.softwareDetails;

    request.post(`/${config.url_prefix}/api/advertiser/externalId/validate`)
        .send({
            data: softwareDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                dispatchServiceError(store, 'ipmob.internal.server.error');
            } else {
                try {
                    const parsedResponse = response.text ? JSON.parse(response.text) : {};

                    if (parsedResponse === 0 || parsedResponse === 1) {
                        removeDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams); // remove PMSC params from local storage
                        if (store.getState().app.dyff?.SHARED_IPM_BANKING_ENABLED) {
                            store.dispatch(businessModelActions.resolveBusinessModel(softwareDetails.systemId, softwareDetails.softwareId));
                        } else if (store.getState().app.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH && isPPM(store.getState().app.userType)) {
                            store.dispatch(actions.changeAppState('LISTING_MODEL'));
                        } else {
                            store.dispatch(actions.changeAppState('CURRENCY_DETAILS'));
                        }
                    } else if (parsedResponse.code === 409 || parsedResponse.code === 400) {
                        dispatchServiceError(store, 'ipmob.software_details.invalid');
                    } else if (parsedResponse.code === 403) {
                        store.dispatch(actions.showIneligibleForm('NO_SOFTWARE_INELIGIBILTY'));
                    } else {
                        dispatchServiceError(store, 'ipmob.error.process.request');
                    }
                } catch (e) {
                    dispatchServiceError(store, 'ipmob.error.process.request');
                }
            }
        });
}

export default validateSoftwareDetails;
